import { Regions } from '@wicadu/langscope'

import globalTranslations from '@translations/pages/orders/create-manual-store-orders/global'

export const CREATE_MANUAL_STORE_ORDERS_TRANSLATIONS = {
  [Regions.Global]: globalTranslations,
} as const
